// Precio de una lente que puede llevar tratamiento (ficha de gafas). El
// totalPrecio ya incluye el total del tratamiento, así que no se vuelve a
// sumar; el PVP sí se suma, y el descuento se calcula sobre el conjunto para
// que PVP, descuento y total cuadren aunque lente y tratamiento tengan
// descuentos distintos.
const getLensPrice = (prod) => {
  const pvpTratamiento = parseFloat(prod.pvpTratamiento) || 0;
  const totalTratamiento = parseFloat(prod.totalTratamiento) || 0;
  if (pvpTratamiento === 0 && totalTratamiento === 0) {
    return {
      porcDto: prod.descuento,
      total: prod.totalPrecio,
      pvp: prod.pvp,
    };
  }

  const pvp = (parseFloat(prod.pvp) || 0) + pvpTratamiento;
  const total = parseFloat(prod.totalPrecio) || 0;
  return {
    porcDto: pvp > 0 ? (1 - total / pvp) * 100 : 0,
    total,
    pvp,
  };
};

export const prepareOrder = (data, id, patientId, category, indexFrom = 1) => {
  const lines = [];

  // Prod 1

  let p = {
    id: "c-" + indexFrom,
    code: data.prod1.codigo,
    description:
      data.prod1.marca +
      " " +
      (data.prod1.modeloNombreComercial ??
        data.prod1.modelo ??
        data.prod1.nombreComercial ??
        ""),
    porcDto: data.prod1.descuento,
    porcIva: -1,
    total: data.prod1.totalPrecio,
    pvp: data.prod1.pvp,
  };
  p.description = p.description.trim();

  lines.push(p);

  // Prod 2

  p = {
    id: "c-" + (indexFrom + 1),
    code: data.prod2.codigo,
    description:
      data.prod2.marca +
      " " +
      (data.prod2.modeloNombreComercial ??
        data.prod2.modelo ??
        data.prod2.nombreComercial ??
        ""),
    porcIva: -1,
    ...getLensPrice(data.prod2),
  };
  p.description = p.description.trim();

  lines.push(p);

  // Prod 3

  p = {
    id: "c-" + (indexFrom + 2),
    code: data.prod3.codigo,
    description:
      data.prod3.marca +
      " " +
      (data.prod3.modeloNombreComercial ??
        data.prod3.modelo ??
        data.prod3.nombreComercial ??
        ""),
    porcIva: -1,
    ...getLensPrice(data.prod3),
  };
  p.description = p.description.trim();

  lines.push(p);

  // Extras

  let counter = indexFrom + 3;
  data.extras.forEach((extra) => {
    const p = {
      id: "c-" + counter,
      code: extra.codigo,
      description: extra.descripcion,
      porcDto: extra.dto,
      porcIva: extra.iva,
      total: extra.total,
      pvp: extra.pvp,
    };
    counter++;
    lines.push(p);
  });

  const order = {
    cardId: id,
    patientId,
    category,
    lines,
  };

  return order;
};
